// WHY — ad-set table for the account page. Renders the placeholder rows from
// `getAdSetsForAccount` (B4) until v1.5 ships real Meta ad-set fetching — the
// column structure is the v1.5 contract.

import { fmtInt, fmtMoney } from "../lib/api";

export interface AdSetRow {
  adset_id: string;
  adset_name: string;
  spend_7d: number;
  leads_7d: number;
  cpl_7d: number | null;
  daily_budget: number | null;
}

interface Props {
  rows: AdSetRow[];
  currency: string;
}

const TH_STYLE: React.CSSProperties = {
  fontFamily: "var(--font-mono)",
  fontSize: "var(--fs-xs)",
  letterSpacing: "var(--letter-label)",
  textTransform: "uppercase",
  color: "var(--color-bone-dim)",
  fontWeight: 600,
  padding: "10px 0",
};

const TD_STYLE: React.CSSProperties = {
  padding: "10px 0",
};

const TD_MONO_RIGHT: React.CSSProperties = {
  ...TD_STYLE,
  fontFamily: "var(--font-mono)",
  textAlign: "right",
};

export function AdSetTable(props: Props) {
  const { rows, currency } = props;

  if (rows.length === 0) {
    return (
      <p
        style={{
          color: "var(--color-bone-dim)",
          fontSize: "var(--fs-sm)",
        }}
      >
        No ad sets yet.
      </p>
    );
  }

  return (
    <div style={{ overflowX: "auto" }}>
      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
          fontSize: "var(--fs-sm)",
        }}
      >
        <thead>
          <tr>
            <th style={{ ...TH_STYLE, width: "55%", textAlign: "left" }}>Ad set</th>
            <th style={{ ...TH_STYLE, textAlign: "right" }}>Spend</th>
            <th style={{ ...TH_STYLE, textAlign: "right" }}>Leads</th>
            <th style={{ ...TH_STYLE, textAlign: "right" }}>CPL</th>
            <th style={{ ...TH_STYLE, textAlign: "right" }}>Daily budget</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((r, i) => (
            <tr
              key={r.adset_id}
              style={
                i === 0
                  ? undefined
                  : { borderTop: "1px solid rgba(255,255,255,0.06)" }
              }
            >
              <td style={TD_STYLE}>{r.adset_name}</td>
              <td style={TD_MONO_RIGHT}>
                {r.spend_7d > 0 ? fmtMoney(r.spend_7d, currency) : "—"}
              </td>
              <td style={TD_MONO_RIGHT}>{fmtInt(r.leads_7d)}</td>
              <td style={TD_MONO_RIGHT}>
                {r.cpl_7d !== null ? fmtMoney(r.cpl_7d, currency) : "—"}
              </td>
              <td style={TD_MONO_RIGHT}>
                {r.daily_budget !== null ? fmtMoney(r.daily_budget, currency) : "—"}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
